module.exports = {
	GooglePlay: 'https://play.google.com/store/apps/details?id=com.hunyverse',
	AppleStore: 'https://apps.apple.com/app/hunyverse-share-bible-verses/id1631743223'
}
